/* Categories panel: open/close (same slide-in pattern as cart/profile/
   wishlist) plus two independent levels of tab-switching — the top tabs
   (one per top-level item of the header's navigation menu, so the same
   worlds as the desktop mega menu), and each tab's own sidebar selection
   (Curation/Brands/categories). Both use the same
   toggle-a-class-by-data-attribute approach already used for the CLP
   curation rail's tabs. */
document.addEventListener('DOMContentLoaded', function () {
  var panel = document.getElementById('categoriesPanel');
  var backdrop = document.getElementById('categoriesPanelBackdrop');
  if (!panel || !backdrop) return;

  function openPanel() {
    backdrop.hidden = false;
    requestAnimationFrame(function () {
      backdrop.classList.add('is-visible');
      panel.classList.add('is-open');
    });
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    backdrop.classList.remove('is-visible');
    panel.classList.remove('is-open');
    panel.setAttribute('inert', '');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { backdrop.hidden = true; }, 320);
  }

  window.VroCategoriesPanel = { open: openPanel, close: closePanel };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-categories-panel-open]')) {
      e.preventDefault();
      openPanel();
      return;
    }
    if (e.target.closest('[data-categories-panel-close]') || e.target === backdrop) {
      closePanel();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
  });

  /* The tab row scrolls sideways once the menu has more worlds than fit,
     so bring a tapped tab fully into view. Scrolls only the row itself —
     scrollIntoView would also nudge the fixed panel. */
  function revealTab(tabs, tab) {
    var left = tab.offsetLeft - tabs.offsetLeft;
    var right = left + tab.offsetWidth;
    var pad = 24;
    if (left - pad < tabs.scrollLeft) {
      tabs.scrollTo({ left: Math.max(0, left - pad), behavior: 'smooth' });
    } else if (right + pad > tabs.scrollLeft + tabs.clientWidth) {
      tabs.scrollTo({ left: right + pad - tabs.clientWidth, behavior: 'smooth' });
    }
  }

  /* Top tabs: one per menu world */
  panel.querySelectorAll('.cat-panel-tabs').forEach(function (tabs) {
    tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-cat-tab]');
      if (!tab) return;
      var id = tab.getAttribute('data-cat-tab');

      tabs.querySelectorAll('[data-cat-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
      });
      panel.querySelectorAll('[data-cat-tab-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-cat-tab-panel') === id);
      });
      revealTab(tabs, tab);
    });
  });

  /* Sidebar within each tab. data-cat-sidebar-group scopes the toggle to
     just that tab's own sidebar+content, so switching one tab's selection
     doesn't affect another tab's. */
  panel.querySelectorAll('[data-cat-sidebar-group]').forEach(function (item) {
    item.addEventListener('click', function () {
      var group = item.getAttribute('data-cat-sidebar-group');
      var id = item.getAttribute('data-cat-sidebar');
      var tabPanel = item.closest('[data-cat-tab-panel]');
      if (!tabPanel) return;

      tabPanel.querySelectorAll('[data-cat-sidebar-group="' + group + '"]').forEach(function (el) {
        el.classList.toggle('is-active', el === item);
      });
      tabPanel.querySelectorAll('[data-cat-sidebar-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-cat-sidebar-panel') === id);
      });

      /* A long category list leaves the content scrolled down; each new
         category should open at its heading. */
      var content = tabPanel.querySelector('.cat-content');
      if (content) content.scrollTop = 0;
    });
  });
});
